module.exports = __webpack_public_path__ + "static/media/404.7ffbc21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/404.svg
// module id = 1102
// module chunks = 1